import React from 'react'
import PropTypes from 'prop-types'

import {StyledAutocompletion, StyledButton} from './Autocompletion.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'

const Autocompletion = (props) => {
  const {className, handleOnChange, suggestions, smallSearchbar} = props

  const suggestionsList = suggestions.map((suggest, index) => (
    <StyledButton
      key={index}
      label={suggest}
      variant={ButtonVariantEnum.tertiary}
      onClick={() => handleOnChange(suggest)}
    />
  ))

  return (
    <StyledAutocompletion smallSearchbar={smallSearchbar} className={className}>
      {suggestionsList}
    </StyledAutocompletion>
  )
}

Autocompletion.propTypes = {
  className: PropTypes.string,
  handleOnChange: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  smallSearchbar: PropTypes.bool,
}

export default Autocompletion
